import { validateName } from "./input-validators/input-name";
import { validatePhone } from "./input-validators/input-phone";
import { validateEmail } from "./input-validators/input-email";
import { validateCheckbox } from "./input-validators/input-checkbox";

/**
 * Scripts for handling LP contact forms
 */
const handleSingleForm = (form, popupId) => {
    /* eslint-disable */
    const apiDomain = apiSettings.apiDomain;
    /* eslint-enable */
    const namesEndpoint = '/dictionaries/names';
    const configEndpoint = '/loan-calculator/configuration';
    const leadEndpoint = '/account/add-lead';
    const namesUrl = apiDomain + namesEndpoint;
    const configUrl = apiDomain + configEndpoint;
    const leadUrl = apiDomain + leadEndpoint;

    //Fields
    const nameInput = document.getElementById('lp-form-name');
    const phoneInput = document.getElementById('lp-form-phone');
    const emailInput = document.getElementById('lp-form-email');
    const checkboxInput = document.getElementById('lp-form-checkbox');

    //Errors
    const errorMessageName = document.getElementById('error-message-name');
    const errorMessagePhone = document.getElementById('error-message-phone');
    const errorMessageEmail = document.getElementById('error-message-email');
    const errorMessageCheckbox = document.getElementById('error-message-checkbox');
    const errorMessageSubmit = document.getElementById('error-message-submit');

    //RRSO
    let rrsoValue;
    const rrsoField = document.getElementById('lp-form-rrso');

    const submitButton = document.getElementById('submit-btn');

    //Inputs button validation
    let isValidName = false;
    let isValidPhone = false;
    let isValidEmail = false;
    let isValidCheckbox = false;

    getRrso();

    if (nameInput) {
        validateName(namesUrl, nameInput);
    }
    if (phoneInput) {
        validatePhone(phoneInput);
    }
    if (emailInput) {
        validateEmail(emailInput);
    } else {
        isValidEmail = true;
    }
    if (checkboxInput) {
        validateCheckbox(checkboxInput);
    }

    function getRrso() {
        fetch(configUrl)
            .then(response => {
                // Check if the request was successful (status code 200 OK)
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                // Parse the response body as JSON
                return response.json();
            })
            .then(responseData => {
                rrsoValue = responseData.rrso.toFixed(2).replace('.', ',') + '%';
                rrsoField.textContent = rrsoField.textContent + rrsoValue;
            })
            .catch(error => {
                // Handle errors during the fetch
                console.error('Fetch error:', error);
            });
    }

    document.addEventListener('nameValidity', function (event) {
        isValidName = event.detail.isValid;
    });
    document.addEventListener('phoneValidity', function (event) {
        isValidPhone = event.detail.isValid;
    });
    document.addEventListener('emailValidity', function (event) {
        isValidEmail = event.detail.isValid;
    });
    document.addEventListener('checkboxValidity', function (event) {
        isValidCheckbox = event.detail.isValid;
    });

    // Function to validate a single input field and display error if needed
    function validateField(inputElement) {
        let isValid = false;

        switch (inputElement) {
            case nameInput:
                errorMessageName.style.display = isValidName ? 'none' : 'flex'; // Display error message if field is invalid
                isValid = isValidName;
                break;
            case phoneInput:
                errorMessagePhone.style.display = isValidPhone ? 'none' : 'flex';
                isValid = isValidPhone;
                break;
            case emailInput:
                errorMessageEmail.style.display = isValidEmail ? 'none' : 'flex';
                isValid = isValidEmail;
                break;
            case checkboxInput:
                errorMessageCheckbox.style.display = isValidCheckbox ? 'none' : 'flex';
                isValidCheckbox ? checkboxInput.classList.remove('form__checkbox--error') : checkboxInput.classList.add('form__checkbox--error');
                isValid = isValidCheckbox;
                break;
        }

        // Update input field class based on error status
        if (isValid) {
            inputElement.classList.remove('form__input--error');
        } else {
            inputElement.classList.add('form__input--error');
        }
        return isValid;
    }

    function disableSubmitButton(state) {
        submitButton.disabled = state;
    }

    // Function to format phone number
    function formatPhoneNumber(phoneNumber) {
        return phoneNumber.replace(/[^0-9+]/g, '');
    }

    function checkIfNotEmpty(input) {
        return input.value !== '';
    }

    function pushToDataLayer(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);
    }

    function sendData() {
        const formData = new FormData(form);
        const currentUrl = window.location.href;
        const searchParams = new URLSearchParams(new URL(currentUrl).search);
        const affiliateIdUrl = searchParams.get('utm_affid');
        const affiliateId = affiliateIdUrl !== null && affiliateIdUrl !== undefined && affiliateIdUrl !== '' ? parseInt(affiliateIdUrl, 10) : 9;

        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const encodedCredentials = btoa('itm:xH5uAbYtyW');
        headers.append('Authorization', 'Basic ' + encodedCredentials);

        let emailData = '';
        if (emailInput) {
            emailData = formData.get('your-email');
        }

        const request = {
            affiliateId: affiliateId,
            agreements: '',
            email: emailData,
            name: formData.get('your-name'),
            phoneNumber: formatPhoneNumber(formData.get('your-phone')),
        };

        // Check each checkbox individually
        if (formData.get('acceptance-email')) {
            request.agreements += 'CALLBACK';
        }

        if (formData.get('acceptance-phone')) {
            if (request.agreements) {
                request.agreements += ',';
            }
            request.agreements += 'CALLBACK_KONTAKT';
        }

        if (formData.get('acceptance-processing')) {
            if (request.agreements) {
                request.agreements += ',';
            }
            request.agreements += 'CALLBACK_DRONN';
        }

        fetch(leadUrl, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(request), // Convert request object to JSON string
        }).then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json(); // Parse response body as JSON
        }).then(responseData => {
            // Trigger confirmation popup after successful fetch
            if (responseData) {
                const leadId = responseData.data.leadId;

                if (errorMessageSubmit) errorMessageSubmit.style.display = 'none';
                /* eslint-disable no-undef */
                if (popupId) PUM.open(popupId, function () {
                    const pagePath = window.location.pathname;
                    const dataLayerEvent = {
                        'event' : 'leadCreated',
                        'category' : 'Registrations',
                        'action' : 'Lead created',
                        'pagePath' : pagePath,
                        'leadId' : leadId
                    }
                    pushToDataLayer(dataLayerEvent);
                });
                /* eslint-enable no-undef */
            }
        }).catch(error => {
            // Handle errors
            console.error('Fetch error:', error);
            if (errorMessageSubmit) errorMessageSubmit.style.display = 'flex';
        });
    }

    let wpcf7Elm = document.querySelector('.wpcf7');

    wpcf7Elm.addEventListener('wpcf7submit', function (event) {
        disableSubmitButton(true);
        //Hide error message if there is one
        if (errorMessageSubmit) errorMessageSubmit.style.display = 'none';

        // Check if user doesn't clear field and it is not empty
        if(!checkIfNotEmpty(nameInput)) isValidName = false; //If field is empty change validity to false, in other case do not change it
        if (!checkIfNotEmpty(phoneInput)) isValidPhone =  false;
        if (emailInput) {
            if (!checkIfNotEmpty(emailInput)) isValidEmail = false;
        }

        // Check the validity of all fields
        if (nameInput) isValidName = validateField(nameInput);
        if (phoneInput) isValidPhone = validateField(phoneInput);
        if (emailInput) {
            isValidEmail = validateField(emailInput);
        }  else { //Case there is no email field
            isValidEmail = true;
        }
        if (checkboxInput) isValidCheckbox = validateField(checkboxInput);

        // Check if fields are ok and if form should be sent
        if (emailInput) {
            // Prevent form submission if any field is invalid
            if (!isValidName || !isValidPhone || !isValidEmail || !isValidCheckbox) {
                event.preventDefault();
            } else {
                sendData(); // Send data only if all fields are valid
            }
        } else { // Without email
            if (!isValidName || !isValidPhone || !isValidCheckbox) {
                event.preventDefault();
            } else {
                sendData();
            }
        }
    }, false);
}
export { handleSingleForm };
